import axios from "axios";

const envUrl = process.env.REACT_APP_BACKEND_URL;
const sameOrigin = typeof window !== "undefined" ? window.location.origin : envUrl;
const baseOrigin = envUrl && envUrl.startsWith(sameOrigin) ? envUrl : sameOrigin;

export const api = axios.create({
  baseURL: `${baseOrigin}/api`,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const fmtAUD = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 }).format(n || 0);

export const fmtNum = (n) => new Intl.NumberFormat("en-AU").format(Math.round(n || 0));

export const fmtCompact = (n) =>
  new Intl.NumberFormat("en-AU", { notation: "compact", maximumFractionDigits: 1 }).format(n || 0);
